import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Center,
  Heading,
  Text,
  Textarea,
  Button,
  VStack,
  useToast,
  FormControl,
  FormLabel,
  FormHelperText,
} from "@chakra-ui/react";
import { denyClient } from "api/client";
import { useDispatch } from "react-redux";

const ClientDeny = () => {
  const { token } = useParams();
  const toast = useToast();
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const handleDeny = async () => {
    if (!token) {
      setError("Invalid token");
      return;
    }

    setIsSubmitting(true);
    try {
      await dispatch(denyClient(token, comment));
      setSuccess(true);
      toast({
        title: "Client denied successfully",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      setError(error.response?.data?.message || "An unexpected error occurred");
      toast({
        title: "Denial failed",
        description:
          error.response?.data?.message || "An unexpected error occurred",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box pt={{ base: "130px", md: "80px" }} px="25px">
      <Center flexDirection="column" py={10}>
        <Heading mb={6}>Client Denial</Heading>

        {!success && !error && (
          <VStack spacing={4} width="100%" maxW="600px">
            <Text mb={4}>
              Please provide a reason for denying this client request:
            </Text>

            <FormControl id="comment">
              <FormLabel>Reason for denial</FormLabel>
              <Textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Please provide details about why you are denying this client..."
                size="md"
                resize="vertical"
                rows={5}
              />
              <FormHelperText>
                This information will be shared with the client and internal
                team.
              </FormHelperText>
            </FormControl>

            <Button
              colorScheme="red"
              isLoading={isSubmitting}
              loadingText="Submitting"
              onClick={handleDeny}
              size="lg"
              width="100%"
              mt={4}
            >
              Submit Denial
            </Button>
          </VStack>
        )}

        {success && (
          <Box textAlign="center">
            <Text fontSize="xl" color="green.500" mb={4}>
              Client denial processed successfully
            </Text>
            <Text>
              The client has been denied access and notified with your comments.
            </Text>
          </Box>
        )}

        {error && (
          <Box textAlign="center">
            <Text fontSize="xl" color="red.500" mb={4}>
              Denial Process Failed
            </Text>
            <Text mb={4}>{error}</Text>
            <Text>
              Please contact support if you continue to experience issues.
            </Text>
            {!success && (
              <Button mt={4} onClick={() => setError(null)} colorScheme="blue">
                Try Again
              </Button>
            )}
          </Box>
        )}
      </Center>
    </Box>
  );
};

export default ClientDeny;
